export const getLocationPathName = () => window.location.pathname;

export const replaceState = (url: string) => window.history.replaceState({}, '', url);
export const pushState = (url: string, reload = false) => {
  window.history.pushState({}, '', url);
  if (reload) {
    window.location.reload();
  }
};
